import { useEffect, useRef, type ReactElement } from 'react';
import { Box, Divider, Text } from '@citibox-panel/ui';

export interface PageIntroProps {
  // Set by the host only for a move made from inside the panel.
  focusHeadingOnArrival?: boolean;
}

// The screen's own words: what programme it belongs to and what it is. Page content rather than
// chrome — it scrolls, the band above it does not.
//
// What the permission DOES lives in `PermissionSummary`, one column down: it explains the counter,
// so it reads beside the number rather than above the whole grid.
//
// TODO: i18n — copy en ES hasta Fase 1.
export function PageIntro({ focusHeadingOnArrival = false }: PageIntroProps): ReactElement {
  const titleRef = useRef<HTMLElement>(null);
  useEffect(() => {
    if (focusHeadingOnArrival) titleRef.current?.focus();
  }, [focusHeadingOnArrival]);
  return (
    <Box sx={{ mb: 4 }}>
      {/* Body tone, not the quieter `secondary`: that one is #ACA5BB, 2.37:1 on white — below AA
          for body text and below 3:1 for large text. It is reserved for in-input placeholders. */}
      <Text variant="overline" component="p" bold dense>
        AMAZON KEY FOR BUSINESS · PUERTAS DE COMUNIDAD
      </Text>
      {/* Vertical margin only: the rule spans the content column it sits in rather than being
          inset from it, so the eyebrow above reads as a header over this block, not as its first
          line. */}
      <Divider sx={{ my: 2 }} />
      {/* `h5` + bold — the same type as «Buzón {matrícula}» in the «Entrega» detail, so the two
          surfaces title their subject identically. The heading LEVEL is unrelated to the variant:
          this is still the document's `h1`. */}
      <Text ref={titleRef} focusTarget variant="h5" component="h1" bold>
        Acceso de Amazon a ubicaciones
      </Text>
    </Box>
  );
}
